import { Epic } from 'redux-observable';
import { of, from } from 'rxjs';
import { mergeMap, map, catchError, filter } from 'rxjs/operators';
import { RootState } from '../store';
import {
  fetchSchedulerConfigsRequested,
  fetchSchedulerConfigsSucceeded,
  fetchSchedulerConfigsFailed,
  createSchedulerConfigRequested,
  createSchedulerConfigSucceeded,
  createSchedulerConfigFailed,
  updateSchedulerConfigRequested,
  updateSchedulerConfigSucceeded,
  updateSchedulerConfigFailed,
  deleteSchedulerConfigRequested,
  deleteSchedulerConfigSucceeded,
  deleteSchedulerConfigFailed,
  fetchSchedulerLogsRequested,
  fetchSchedulerLogsSucceeded,
  fetchSchedulerLogsFailed,
  fetchSchedulerStatusRequested,
  fetchSchedulerStatusSucceeded,
  fetchSchedulerStatusFailed,
  manuallyTriggerSchedulerRequested,
  manuallyTriggerSchedulerSucceeded,
  manuallyTriggerSchedulerFailed
} from '../slices/smsSchedulerSlice';
import {
  getSchedulerConfigs,
  createSchedulerConfig,
  updateSchedulerConfig,
  deleteSchedulerConfig,
  getSchedulerLogs,
  getSchedulerStatus,
  manuallyTriggerScheduler
} from '@/services/api';

// Fetch Scheduler Configurations Epic
export const fetchSchedulerConfigsEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === fetchSchedulerConfigsRequested.type),
    mergeMap((action: any) => {
      const isActive = action.payload?.isActive;
      return from(getSchedulerConfigs(isActive)).pipe(
        map((response) => fetchSchedulerConfigsSucceeded(response)),
        catchError((error) => of(fetchSchedulerConfigsFailed(error.message || 'Failed to fetch scheduler configurations')))
      );
    })
  );

// Create Scheduler Configuration Epic
export const createSchedulerConfigEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === createSchedulerConfigRequested.type),
    mergeMap((action: any) => {
      const configData = action.payload;
      return from(createSchedulerConfig(configData)).pipe(
        map((response) => createSchedulerConfigSucceeded(response)),
        catchError((error) => of(createSchedulerConfigFailed(error.message || 'Failed to create scheduler configuration')))
      );
    })
  );

// Update Scheduler Configuration Epic
export const updateSchedulerConfigEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === updateSchedulerConfigRequested.type),
    mergeMap((action: any) => {
      const { id, config } = action.payload;
      return from(updateSchedulerConfig(id, config)).pipe(
        map((response) => updateSchedulerConfigSucceeded(response)),
        catchError((error) => of(updateSchedulerConfigFailed(error.message || 'Failed to update scheduler configuration')))
      );
    })
  );

// Delete Scheduler Configuration Epic
export const deleteSchedulerConfigEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === deleteSchedulerConfigRequested.type),
    mergeMap((action: any) => {
      const configId = action.payload;
      return from(deleteSchedulerConfig(configId)).pipe(
        map(() => deleteSchedulerConfigSucceeded(configId)),
        catchError((error) => of(deleteSchedulerConfigFailed(error.message || 'Failed to delete scheduler configuration')))
      );
    })
  );

// Fetch Scheduler Logs Epic
export const fetchSchedulerLogsEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === fetchSchedulerLogsRequested.type),
    mergeMap((action: any) => {
      const filters = action.payload;
      return from(getSchedulerLogs(filters)).pipe(
        map((response) => fetchSchedulerLogsSucceeded(response)),
        catchError((error) => of(fetchSchedulerLogsFailed(error.message || 'Failed to fetch scheduler logs')))
      );
    })
  );

// Fetch Scheduler Status Epic
export const fetchSchedulerStatusEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === fetchSchedulerStatusRequested.type),
    mergeMap(() =>
      from(getSchedulerStatus()).pipe(
        map((response) => fetchSchedulerStatusSucceeded(response)),
        catchError((error) => of(fetchSchedulerStatusFailed(error.message || 'Failed to fetch scheduler status')))
      )
    )
  );

// Manually Trigger Scheduler Epic
export const manuallyTriggerSchedulerEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === manuallyTriggerSchedulerRequested.type),
    mergeMap((action: any) => {
      const configId = action.payload;
      return from(manuallyTriggerScheduler(configId)).pipe(
        map(() => manuallyTriggerSchedulerSucceeded()),
        catchError((error) => of(manuallyTriggerSchedulerFailed(error.message || 'Failed to trigger scheduler')))
      );
    })
  );

export default [
  fetchSchedulerConfigsEpic,
  createSchedulerConfigEpic,
  updateSchedulerConfigEpic,
  deleteSchedulerConfigEpic,
  fetchSchedulerLogsEpic,
  fetchSchedulerStatusEpic,
  manuallyTriggerSchedulerEpic
];

